var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3138 2.33801C9.74704 1.69101 9.43471 0.860116 9.43495 0H6.87309V10.2806C6.85333 10.8369 6.61845 11.3639 6.21792 11.7505C5.81738 12.1371 5.28245 12.3532 4.72576 12.3533C3.54847 12.3533 2.57015 11.3916 2.57015 10.1977C2.57015 8.77168 3.94643 7.70217 5.36416 8.14158V5.52168C2.50383 5.14031 0 7.36224 0 10.1977C0 12.9585 2.28827 14.9235 4.71747 14.9235C7.32079 14.9235 9.43495 12.8093 9.43495 10.1977V4.98278C10.4738 5.72883 11.721 6.12911 13 6.12691V3.56505C13 3.56505 11.4413 3.63967 10.3138 2.33801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.4bc5853c24102abb17ee2e4e8f2f8d93.svg";
export { ForwardRef as ReactComponent };